import { cn } from '@/lib/utils';

type SectionHeadingProps = {
  title: string;
  subtitle?: string;
  className?: string;
  align?: 'left' | 'center';
  as?: 'h1' | 'h2';
};

export default function SectionHeading({
  title,
  subtitle,
  className,
  align = 'center',
  as: Tag = 'h2',
}: SectionHeadingProps) {
  return (
    <div
      className={cn(
        align === 'center' ? 'text-center' : 'text-left',
        className
      )}
    >
      {subtitle && (
        <p className="font-sans text-xs font-medium uppercase tracking-[0.16em] sm:tracking-[0.25em] mb-3 text-[#5A5A6E]">
          {subtitle}
        </p>
      )}
      <Tag className="font-sans text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-light leading-tight text-[#1A1A2E]">
        {title}
      </Tag>
    </div>
  );
}
